// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewImage_wrapper__2kjZZ","image":"ViewImage_image__lkgQu","close":"ViewImage_close__LBr5d"};